import { render, staticRenderFns } from "./ParticlesBackground.vue?vue&type=template&id=1e143ce2&scoped=true"
import script from "./ParticlesBackground.vue?vue&type=script&lang=js"
export * from "./ParticlesBackground.vue?vue&type=script&lang=js"
import style0 from "./ParticlesBackground.vue?vue&type=style&index=0&id=1e143ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e143ce2",
  null
  
)

export default component.exports